const getData = (state, selector) => {
  const data = state.GroupsComponent.updateGroupDialog
    ? state.GroupsComponent.updateGroupDialog
    : state
  return !data ? null : selector(data)
}

const isOpen = state => getData(state, data => data.opened)
const getId = state => getData(state, data => data.id)

export { isOpen, getId }
